import RequestAccount from './RequestAccount.js'

export default RequestAccount
